import { render, staticRenderFns } from "./CircleRemind.vue?vue&type=template&id=657e4f1f&"
import script from "./CircleRemind.vue?vue&type=script&lang=js&"
export * from "./CircleRemind.vue?vue&type=script&lang=js&"
import style0 from "./CircleRemind.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports